/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hof_LoadingInputs */

const en_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading moments…`)
};

const es_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando momentos…`)
};

const de_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momente werden geladen…`)
};

const zh_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载精彩瞬间…`)
};

const ar_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ تحميل اللحظات…`)
};

const fr_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moments de chargement…`)
};

const vi_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải khoảnh khắc…`)
};

const sw_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inapakia matukio…`)
};

const th_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังโหลดช่วงเวลา…`)
};

const bs_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Učitavanje trenutaka…`)
};

const ja_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`思い出を読み込み中…`)
};

const ko_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로딩…`)
};

const pt_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando momentos…`)
};

const it_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento dei momenti…`)
};

const sv_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laddar ögonblick…`)
};

const nl_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momenten laden…`)
};

const da_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indlæser øjeblikke…`)
};

const nb_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laster inn øyeblikk…`)
};

const fi_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladataan hetkiä…`)
};

const pl_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wczytywanie momentów…`)
};

const ru_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка моментов…`)
};

const tr_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anlar yükleniyor…`)
};

const hi_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्षण लोड हो रहा है…`)
};

const id_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat momen…`)
};

const ms_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuatkan momen…`)
};

const cs_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načítání momentů…`)
};

const el_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Φόρτωση στιγμών…`)
};

const he_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`טוען רגעים…`)
};

const af_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laai tans oomblikke…`)
};

const hu_hof_loading = /** @type {(inputs: Hof_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pillanatok betöltése…`)
};

/**
* | output |
* | --- |
* | "Loading moments…" |
*
* @param {Hof_LoadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const hof_loading = /** @type {((inputs?: Hof_LoadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hof_LoadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_hof_loading(inputs)
	if (locale === "de") return de_hof_loading(inputs)
	if (locale === "zh") return zh_hof_loading(inputs)
	if (locale === "ar") return ar_hof_loading(inputs)
	if (locale === "fr") return fr_hof_loading(inputs)
	if (locale === "vi") return vi_hof_loading(inputs)
	if (locale === "sw") return sw_hof_loading(inputs)
	if (locale === "th") return th_hof_loading(inputs)
	if (locale === "bs") return bs_hof_loading(inputs)
	if (locale === "ja") return ja_hof_loading(inputs)
	if (locale === "ko") return ko_hof_loading(inputs)
	if (locale === "pt") return pt_hof_loading(inputs)
	if (locale === "it") return it_hof_loading(inputs)
	if (locale === "sv") return sv_hof_loading(inputs)
	if (locale === "nl") return nl_hof_loading(inputs)
	if (locale === "da") return da_hof_loading(inputs)
	if (locale === "nb") return nb_hof_loading(inputs)
	if (locale === "fi") return fi_hof_loading(inputs)
	if (locale === "pl") return pl_hof_loading(inputs)
	if (locale === "ru") return ru_hof_loading(inputs)
	if (locale === "tr") return tr_hof_loading(inputs)
	if (locale === "hi") return hi_hof_loading(inputs)
	if (locale === "id") return id_hof_loading(inputs)
	if (locale === "ms") return ms_hof_loading(inputs)
	if (locale === "cs") return cs_hof_loading(inputs)
	if (locale === "el") return el_hof_loading(inputs)
	if (locale === "he") return he_hof_loading(inputs)
	if (locale === "af") return af_hof_loading(inputs)
	if (locale === "hu") return hu_hof_loading(inputs)
	return en_hof_loading(inputs)
});